import type { Mark } from '@mui/base';
import { Typography } from '@mui/material';

export const peopleMarks: Mark[] = [
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        none
      </Typography>
    ),
    value: 0,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        1
      </Typography>
    ),
    value: 1,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        2
      </Typography>
    ),
    value: 2,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        3
      </Typography>
    ),
    value: 3,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        4
      </Typography>
    ),
    value: 4,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        many
      </Typography>
    ),
    value: 5,
  },
];

export const fuelLevelMarks = (smallScreen: boolean): Mark[] => [
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        {smallScreen ? '?' : 'Unknown'}
      </Typography>
    ),
    value: 0,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        {smallScreen ? 'E' : 'Nearly empty'}
      </Typography>
    ),
    value: 1,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        1/4
      </Typography>
    ),
    value: 2,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        1/2
      </Typography>
    ),
    value: 3,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        3/4
      </Typography>
    ),
    value: 4,
  },
  {
    label: (
      <Typography
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
        variant="body2"
      >
        {smallScreen ? 'F' : 'Nearly full'}
      </Typography>
    ),
    value: 5,
  },
];
